var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.steps),function(step){return _c('section',{key:step.id,staticClass:"step"},[_c('h1',[_vm._v(_vm._s(step.title))]),_c('p',[_vm._v(_vm._s(step.description))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }